import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import React, { useState } from 'react'
import { Button, IconButton, TextareaAutosize, Theme } from '@mui/material'
import { useShow } from '../../../../hooks/useShow'
import { DialogContent, Modal } from '../../../Modal/Modal'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { helpQueryKey } from '../../../../api/queries'
import { queryHelp } from '../../../../api/queries'
import { IDocument, IUpdateHelp } from '../../../../api/types/document'
import { fromAxiosError } from '../../../../context/GlobalError'
import { ErrorHandler } from '../../../ErrorHandler/ErrorHandler'
import { FormRow } from '../../../FormRow/FormRow'
import { ErrorExplanation } from '../../../ErrorExplanation/ErrorExplanation'
import { SubmitButton } from '../../../SubmitButton/SubmitButton'
import { useApiErrors } from '../../../../hooks/useApiErrors'
import { mutationUpdateHelp } from '../../../../api/mutations'
import { EditIconButton } from '../../../EditIconButton/EditIconButton'
import { MarkdownComponent } from '../../../Markdown/MarkdownComponent'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alignToRight: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
    },
  })
)

export const Help = () => {
  const queryClient = useQueryClient()
  const classes = useStyles()
  const { show, doHide, doShow } = useShow()
  const [helpDoc, setHelpDoc] = useState('')
  const [editMode, setEditMode] = useState(false)
  const { apiErrors, setApiErrors, setApiErrorsFromAxios } = useApiErrors()
  const {
    isLoading,
    error,
    data: help,
  } = useQuery<IDocument>(helpQueryKey(), queryHelp, {
    onSuccess: (data: IDocument) => {
      setHelpDoc(data.contents)
    },
  })
  const { mutate: updateHelpMutation, isLoading: isMutating } = useMutation(
    (update: IUpdateHelp) => mutationUpdateHelp(update),
    {
      onError: (err: any) => {
        setApiErrorsFromAxios(err, 'Nie udało się zaktualizować pomocy')
      },
      onSuccess: async () => {
        setApiErrors([])
        queryClient.invalidateQueries(helpQueryKey())
      },
    }
  )

  const handleSubmit = (e: any) => {
    e.preventDefault()
    updateHelpMutation({ contents: helpDoc })
    setEditMode(false)
  }
  const handleClose = () => {
    doHide()
    setEditMode(false)
  }

  return (
    <>
      <IconButton size="large" color="inherit" onClick={doShow}>
        <HelpOutlineIcon />
      </IconButton>

      <Modal fullWidth={true} maxWidth={'md'} open={show} onClose={handleClose} title="Help">
        <DialogContent dividers>
          <ErrorHandler loading={isLoading} error={fromAxiosError(error)}>
            {!editMode && help && <MarkdownComponent rawMarkdown={help.contents} />}

            {editMode && (
              <form onSubmit={handleSubmit}>
                <FormRow>
                  <ErrorExplanation errors={apiErrors} />
                </FormRow>
                <FormRow>
                  <TextareaAutosize
                    style={{ width: '100%' }}
                    name="contents"
                    value={helpDoc}
                    onChange={e => setHelpDoc(e.target.value)}
                    minRows={10}
                  />
                </FormRow>
                <div className={classes.alignToRight}>
                  <Button
                    style={{ marginRight: '4px' }}
                    variant="outlined"
                    onClick={() => setEditMode(false)}
                  >
                    Anulu
                  </Button>
                  <SubmitButton disabled={isMutating}>Zapisz</SubmitButton>
                </div>
              </form>
            )}
            {!editMode && (
              <div className={classes.alignToRight}>
                <EditIconButton onClick={() => setEditMode(true)} />{' '}
              </div>
            )}
          </ErrorHandler>
        </DialogContent>
      </Modal>
    </>
  )
}
